<template>
    <div class="scrollableArea">
        <navigator :product="reservation.product" v-if="!$route.meta.reschedule"></navigator>

        <filters :availableResources="availableResources" :availableDurations="availableDurations" v-on:filterChanged="filterChanged" :filters="filters"></filters>

        <div class="container-fluid scrollThis" v-if="events.length > 0">
            <single-day v-for="dayGroup in eventsGroupedByDay" :key="dayGroup.date" :product="getReservationSelectedProduct" :group="dayGroup" :reservationDetails="userBookingInfo"></single-day>
        </div>

        <div v-if="loadingEvents" class="dark fs-larger font-weight-600 text-center mt-4">
            <loader></loader>
        </div>

        <div class="dark fs-large text-center font-weight-600 mt-4" v-if="!loadingEvents && filteredEvents.length == 0">
            No events found
        </div>
    </div>
</template>

<script>
import navigator from './Availability/Navigator'
import filters from './Availability/Filters'
import singleDay from './Availability/SingleDay'
import Loader from '@/tools/loaders/loader1'

import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            events: [],
            loadingEvents: false,
            filters:{
                dateRange: [
                    moment().startOf('day').format('YYYY-MM-DD'),
                    moment().add(7, 'days').endOf('day').format('YYYY-MM-DD')
                ],
                resourceId: null,
                duration: null,
            },
            userBookingInfo: {}
        }
    },
    created() {
        // If coming with product id on the url
        if (this.$route.params.id && this.getReservation.event.product) {
            this.getReservation.event.product.id = this.$route.params.id;
            this.getEvents();
        } else {
            if (this.reservation.product == null || !this.selectedProductId) {
                // If page refreshed go to reservations
                this.$router.push('/reservations');
            } else {
                this.getEvents();
            }
        }

        this.initUserBookingInformations();
    },
    computed: {
        ...mapGetters([
            'getReservation',
            'getReservationSelectedProduct',
            'account'
        ]),
        reservation(){
            return this.getReservation;
        },
        selectedProductId() {
            if (this.getReservation.product && this.getReservation.product.id) {
                return this.getReservation.product.id;
            } else if (this.getReservation.event && this.getReservation.event.product && this.getReservation.event.product.id) {
                return this.getReservation.event.product.id;
            } else {
                return false;
            }
        },
        availableResources() {
            let resources = [];
            let allEvents = this.events;

            for (let event of allEvents) {
                if (event.product.resources) {
                    for (let resource of event.product.resources) {
                        let addResource = true;

                        for (let storedResource of resources){
                            if(storedResource.id && storedResource.id == resource.id){
                                addResource = false;
                            }
                        }

                        // The above is because comapring with indexOf was not successfull because of proto object
                        if(addResource){
                            resources.push(resource);
                        }
                    }
                }
            }

            return resources;
        },
        availableDurations() {
            let durations = [];
            let allEvents = this.events;

            for (let event of allEvents) {
                if (durations.indexOf(event.product.duration) == -1) {
                    durations.push(event.product.duration);
                }
            }

            return durations;
        },
        filteredEvents() {
            let filteredEvents = this.events;

            return filteredEvents;
        },
        eventsGroupedByDay() {
            let eventsToGroup = this.filteredEvents;
            let groupedArr = [];

            for (let event of eventsToGroup) {
                let currentEventDate = moment(event.start).format('YYYY-MM-DD');

                // If groupArr is empty, create first group
                if (groupedArr.length == 0) {
                    groupedArr.push({
                        date: currentEventDate,
                        eventIds: [event.id],
                        events: [event]
                    });
                } else {
                    // The next events
                    let createNewGroup = true;
                    for (let group of groupedArr) {
                        // If event happens on the same day as this group
                        if (currentEventDate == group.date) {
                            createNewGroup = false;
                            group.eventIds.push(event.id);
                            group.events.push(event);
                        }
                    }

                    if (createNewGroup) {
                        groupedArr.push({
                            date: currentEventDate,
                            eventIds: [event.id],
                            events: [event]
                        });
                    }
                }
            }

            groupedArr.sort(function compare(a, b) {
                if (moment(a.date).diff(b.date) < 0) {
                    return -1;
                }
                if (moment(a.date).diff(b.date) > 0) {
                    return 1;
                }
                // A must be equal to B
                return 0;
            })

            return groupedArr;
        }
    },
    methods:{
        ...mapActions([
            'refreshAccountData'
        ]),
        initUserBookingInformations() {
            this.userBookingInfo.accessType = this.account.accessType;
            this.userBookingInfo.totalPaxReservation = this.reservation.paxTotal;
        },
        getEvents() {
            this.loadingEvents = true;
            let response = axios.get('/api/booking/ProductAvailability', {
                params: {
                    supplierId: this.account.supplierId,
                    productId: this.selectedProductId,
                    dtStart: moment(this.filters.dateRange[0]).format("YYYY-MM-DD HH:mm:ss"),
                    dtEnd: moment(this.filters.dateRange[1]).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                }
            }).then(response => {
                this.loadingEvents = false;
                
                if (response && response.status === 200 && response.data) {
                    this.events = response.data;
                } else {
                    this.events = [];
                }
            }).catch(error => {
                this.loadingEvents = false;
                this.events = [];
            })
        },
        filterChanged(filters) {
            this.filters = filters;
            this.getEvents();
        }
    },
    components: {
        navigator,
        filters,
        singleDay,
        Loader
    }
}
</script>

<style lang="scss">
    .scrollableArea {
        display: flex;
        height: 94vh;
        flex-direction: column;

        .scrollThis {
            overflow: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// Availability.vue?567e6c54